import React from 'react';
import { Link } from 'react-router-dom';

var Icon = (props) => {
    return (
        <div className="icon">
            {props.link_type === "internal" ?
                <Link to={props.link}><i className={props.classNames.join(" ")}></i>
                    <p>{props.name}</p></Link> :
                <a href={props.link} target="_blank"><i className={props.classNames.join(" ")}></i>
                    <p>{props.name}</p></a>
            }
        </div>
    );
}

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icons/Icon.js